export const CONNECT_DISPATCH_VEHICLE_DEFAULTS = {
  ERROR_STATE: {
    commander: {
      cpf: '',
      phone: '',
    },
    driver: {
      cpf: '',
    },
    patrolmans: {
      cpf: '',
    },
    km: '',
    returnError: '',
  },

  USER_POSITIONS: {
    DRIVER: {
      cpf: '',
      name: '',
      representation_name: '',
      registration: '',
      position: 'driver'
    },

    COMMANDER: {
      cpf: '',
      name: '',
      representation_name: '',
      registration: '',
      phone: '',
      position: 'commander'
    },

    PATROLMANS: {
      cpf: '',
      name: '',
      representation_name: '',
      registration: '',
      position: 'patrolmans'
    }
  },

  VEHICLE: {
    km: '',
    task: '',
    trackingId: '',
    notes: '',
    cityId: null,
    operationId: null
  },

  DEVICE_SITUATION_OPTIONS: [
    { id: 0, name: 'Em conformidade' },
    { id: 1, name: 'Necessário manutenção simples' },
    { id: 2, name: 'Veículo fora de condições de uso' }
  ]
} as const;

export const createDefaultErrorState = () => ({
  commander: {
    cpf: '',
    phone: '',
  },
  driver: {
    cpf: '',
  },
  patrolmans: {
    cpf: '',
  },
  km: '',
  returnError: '',
});


export const createDefaultDriver = () => ({ ...CONNECT_DISPATCH_VEHICLE_DEFAULTS.USER_POSITIONS.DRIVER });
export const createDefaultCommander = () => ({ ...CONNECT_DISPATCH_VEHICLE_DEFAULTS.USER_POSITIONS.COMMANDER });
export const createDefaultPatrolman = () => ({ ...CONNECT_DISPATCH_VEHICLE_DEFAULTS.USER_POSITIONS.PATROLMANS });
export const createDefaultVehicle = () => ({ ...CONNECT_DISPATCH_VEHICLE_DEFAULTS.VEHICLE });
export const createDefaultDeviceSituationOptions = () => [...CONNECT_DISPATCH_VEHICLE_DEFAULTS.DEVICE_SITUATION_OPTIONS];